/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TrackItMeasurementSoftwareDto
 */
export interface TrackItMeasurementSoftwareDto {
    /**
     * 
     * @type {number}
     * @memberof TrackItMeasurementSoftwareDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementSoftwareDto
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackItMeasurementSoftwareDto
     */
    $type?: TrackItMeasurementSoftwareDtoTypeEnum;
}


/**
 * @export
 */
export const TrackItMeasurementSoftwareDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoTrackItMeasurementSoftwareDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementSoftwareDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TrackItMeasurementSoftwareDtoTypeEnum = typeof TrackItMeasurementSoftwareDtoTypeEnum[keyof typeof TrackItMeasurementSoftwareDtoTypeEnum];



/**
 * Check if a given object implements the TrackItMeasurementSoftwareDto interface.
 */
export function instanceOfTrackItMeasurementSoftwareDto(value?: unknown): value is TrackItMeasurementSoftwareDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TrackItMeasurementSoftwareDtoTypeEnum)[0];
}

export function TrackItMeasurementSoftwareDtoFromJSON(json: any): TrackItMeasurementSoftwareDto {
    return TrackItMeasurementSoftwareDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementSoftwareDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementSoftwareDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TrackItMeasurementSoftwareDtoToJSON(value?: TrackItMeasurementSoftwareDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'name': value['name'],
        '$type': value['$type'],
    });
}

